import { Component, Input, OnInit } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';

import { IconName } from '@fcom/ui-components/components/icons';
import { LoaderTheme } from '@fcom/ui-components/components/loader';

@Component({
  selector: 'fin-kpi',
  templateUrl: './kpi.component.html',
  styleUrls: ['./kpi.component.scss'],
})
export class KpiComponent implements OnInit {
  protected readonly LoaderTheme = LoaderTheme;

  @Input() title: string;

  @Input() value: string;

  @Input() delta: number;

  deltaIcon: IconName;

  ngOnInit(): void {
    this.deltaIcon = this.delta > 0 ? SvgLibraryIcon.ARROW_UP : SvgLibraryIcon.ARROW_DOWN;
  }
}
